import { AloftPrice, MarketAdjustments } from '@aloft/toolkit-shared';

import { MarketAdjustmentsModalForm } from '../types.ts';
import { inputStringToFloat } from './inputStringToFloat.ts';
import { inputStringToNumber } from './inputStringToNumber.ts';

export function formMarketAdjustmentsToState(
  formMarketAdjustments: MarketAdjustmentsModalForm['marketAdjustments'],
): MarketAdjustments {
  const { version, cachedForms } = formMarketAdjustments;

  return {
    version,
    cachedForms: {
      dateOfSale: {
        ...cachedForms.dateOfSale,
        methodState: {
          ...(cachedForms.dateOfSale.methodState.zillow !== undefined
            ? {
                zillow: cachedForms.dateOfSale.methodState.zillow,
              }
            : {}),
          customMonthlyRate: {
            rate: inputStringToFloat(cachedForms.dateOfSale.methodState.customMonthlyRate.rate),
          },
          customMonthlyPrice: {
            type: cachedForms.dateOfSale.methodState.customMonthlyPrice.type,
            analysisPeriod: cachedForms.dateOfSale.methodState.customMonthlyPrice.analysisPeriod,
            trendsAsPercentages:
              cachedForms.dateOfSale.methodState.customMonthlyPrice.trendsAsPercentages,
            trends: cachedForms.dateOfSale.methodState.customMonthlyPrice.trends.map((trend) => ({
              month: trend.month,
              value: AloftPrice.fromDollarLike(inputStringToNumber(trend.value)).toJSON(),
            })),
          },
        },
      },
      listToSale: {
        selectedMethod: cachedForms.listToSale.selectedMethod,
        methodState: {
          ...(cachedForms.listToSale.methodState.customRatio?.ratio !== undefined &&
          cachedForms.listToSale.methodState.customRatio?.ratio !== ''
            ? {
                customRatio: {
                  ratio: inputStringToFloat(cachedForms.listToSale.methodState.customRatio.ratio),
                },
              }
            : {}),
        },
      },
    },
  };
}
